/*! form-validation */
$(document).ready(function () {
    // Apply maxlength to textarea
    $('.maxlength-140').attr('maxlength', '140');
    $('.maxlength-250').attr('maxlength', '250');
    $('.maxlength-500').attr('maxlength', '500');
    $('.maxlength-1000').attr('maxlength', '1000');
    $('.maxlength-1500').attr('maxlength', '1500');
    $('.maxlength-3000').attr('maxlength', '3000');
});